import { render, staticRenderFns } from "./HeaderSegment.vue?vue&type=template&id=f6054eea&"
import script from "./HeaderSegment.vue?vue&type=script&lang=js&"
export * from "./HeaderSegment.vue?vue&type=script&lang=js&"
import style0 from "./HeaderSegment.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports